import { Dropdown, SelectOption } from "components/dropdown/Dropdown";
import { useField } from "formik";
import { options } from "yargs";
import {
  ParsedWorkflowItem,
  ReferenceData,
  WorkflowBuilderErrors,
  WorkflowReferenceDataNames,
} from "../WorkflowBuilderPage";
import { SetStateAction, useEffect, useState } from "react";
import _ from "lodash";
import { changeWorkflowBuilderReferenceData } from "./WorkflowItem";

import deleteIcon from "assets/Icon_Form_Search_02.png";
import { List } from "./MilestoneTaskPicker";
import ToastMessage, { toastConfig } from "helpers/ToastMessage/ToastMessage";
import { toast } from "react-toastify";

export type MinimiseSelectorProps = {
  setShowSelector: React.Dispatch<SetStateAction<any>>;
  selectedValue: any;
};
export const MinimiseSelector: React.FC<MinimiseSelectorProps> = ({
  setShowSelector,
  selectedValue,
}) => {
  const minimiseSelector = () => {
    if (selectedValue) {
      setShowSelector(false);
    }
  };

  return (
    <div className="MinimiseSelector" onClick={minimiseSelector}>
      {/* <div className="MinimiseIcon"></div> */}
      <img
        src={deleteIcon}
        className="MinimiseIcon"
        alt="Close action type selector"
      />
    </div>
  );
};

interface Props {
  parentOrderNumber: number;
  orderNumber: number;
  fieldName: string;
  triggerOptions: SelectOption[];
  type: "trigger" | "action";
  parsedData: ParsedWorkflowItem | null;
  setParsedData: React.Dispatch<SetStateAction<ParsedWorkflowItem | null>>;
  referenceData: ReferenceData | null;
  setReferenceData: React.Dispatch<SetStateAction<ReferenceData | null>>;
  showTriggerTypeSelector: boolean;
  setShowTriggerTypeSelector: React.Dispatch<SetStateAction<boolean>>;
  workflowBuilderErrors: WorkflowBuilderErrors;
  setWorkflowBuilderErrors: React.Dispatch<
    SetStateAction<WorkflowBuilderErrors>
  >;
  setTempTriggerMilestoneData: React.Dispatch<SetStateAction<List | null>>;
}

const TriggerTypeSelector: React.FC<Props> = ({
  parentOrderNumber,
  orderNumber,
  fieldName,
  triggerOptions,
  type,
  parsedData,
  setParsedData,
  referenceData,
  setReferenceData,
  showTriggerTypeSelector,
  setShowTriggerTypeSelector,
  workflowBuilderErrors,
  setWorkflowBuilderErrors,
  setTempTriggerMilestoneData,
}) => {
  const [relevantErrors, setRelevantErrors] = useState<string[] | null>(null);

  useEffect(() => {
    if (
      workflowBuilderErrors &&
      workflowBuilderErrors.trigger &&
      workflowBuilderErrors.trigger.hasOwnProperty(0)
    ) {
      const tempErrors = workflowBuilderErrors.trigger[0];

      if (Array.isArray(tempErrors) && tempErrors.length > 0) {
        setRelevantErrors(tempErrors);
      } else {
        setRelevantErrors(null);
      }
    } else {
      setRelevantErrors(null);
    }
  }, [workflowBuilderErrors]);

  const [
    tempSelectedOption,
    setTempSelectedOption,
  ] = useState<SelectOption | null>(null);

  useEffect(() => {
    const triggerTypeId = referenceData?.trigger?.workflowTriggerTypesID
      ? referenceData?.trigger?.workflowTriggerTypesID
      : null;

    setTempSelectedOption(
      triggerTypeId
        ? triggerOptions.find(item => item.value === triggerTypeId) ?? null
        : null
    );
  }, []);

  const handleChange = (option: SelectOption) => {
    setTempSelectedOption(option);

    try {
    } catch {
      console.log(
        `Failed to update trigger type for parent orderNumber: ${parentOrderNumber}, orderNumber: ${orderNumber} `
      );
    }
  };

  const triggerTypeId = referenceData?.trigger?.workflowTriggerTypesID
    ? referenceData?.trigger?.workflowTriggerTypesID
    : null;

  const handleSave = () => {
    let attemptChange: boolean = true;

    if (
      tempSelectedOption &&
      tempSelectedOption.label.toLowerCase().trim() !== "submitted survey" &&
      referenceData &&
      referenceData.actions &&
      Array.isArray(referenceData.actions) &&
      referenceData.actions.length > 0 &&
      referenceData.actionTypes &&
      Array.isArray(referenceData.actionTypes) &&
      referenceData.actionTypes.length > 0 &&
      referenceData.triggerTypes &&
      Array.isArray(referenceData.triggerTypes) &&
      referenceData.triggerTypes.length > 0
    ) {
      const actionTypes = referenceData.actionTypes;

      const actionTypeMatch = actionTypes.filter(
        (item: any) => item.name.toLowerCase().trim() === "re-dispatch survey"
      );

      if (
        actionTypeMatch.length === 1 &&
        actionTypeMatch[0].name &&
        typeof actionTypeMatch[0].name === "string" &&
        actionTypeMatch[0].name.toLowerCase().trim() === "re-dispatch survey"
      ) {
        const reDispatchSurveyActionTypeId = actionTypeMatch[0].id;

        const actions = referenceData.actions;

        const actionsContainReDispatchSurveyActions = actions.filter(
          item => item.workflowActionTypesID === reDispatchSurveyActionTypeId
        );

        if (actionsContainReDispatchSurveyActions.length > 0) {
          const currentTriggerTypeMatch = referenceData.triggerTypes.filter(
            item => item.id === referenceData.trigger.workflowTriggerTypesID
          );

          if (
            currentTriggerTypeMatch.length === 1 &&
            typeof currentTriggerTypeMatch[0] === "object" &&
            currentTriggerTypeMatch[0].hasOwnProperty("id") &&
            currentTriggerTypeMatch[0].hasOwnProperty("name")
          ) {
            const currentTriggerTypeData = currentTriggerTypeMatch[0];

            const parsedCurrentTriggerTypeData = {
              value: currentTriggerTypeData.id,
              label: currentTriggerTypeData.name,
            };

            setTempSelectedOption(parsedCurrentTriggerTypeData);
          }

          attemptChange = false;

          toast(
            <ToastMessage
              toastData={[
                {
                  title: "Invalid Actions",
                  text:
                    "Please delete any 'Re-dispatch survey' actions when selecting a 'Submitted survey' trigger",
                },
              ]}
              className="ToastError"
            />,
            {
              ...toastConfig,
            }
          );
        }
      }
    }

    if (attemptChange && parsedData && tempSelectedOption && referenceData) {
      const newValue = tempSelectedOption.value;

      let newReferenceData = _.cloneDeep(referenceData);

      let newTriggerData: any = referenceData.trigger
        ? _.cloneDeep(referenceData.trigger)
        : {};

      newTriggerData.workflowTriggerTypesID = newValue;

      const keysToNotChange = [
        "orderNumber",
        "parentOrderNumber",
        "workflowTriggersID",
        "workflowTriggerTypesID",
        "childWorkflowActionID",
        "nodeFirstActionId",
        "nodeApprovalId",
        "childWorkflowApprovalID",
        "bNewlyCreated",
      ];

      let keysChanged: string[] = [];

      Object.keys(newTriggerData).forEach((key: string) => {
        if (!keysToNotChange.includes(key)) {
          newTriggerData[key] = null;
          keysChanged.push(key);
        }
      });

      let newParsedData: any = _.cloneDeep(parsedData);

      newParsedData.workflowTriggerTypesID = newValue;

      keysChanged.forEach(key => {
        if (newParsedData.hasOwnProperty(key)) {
          newParsedData[key] = null;
        }
      });

      // No existing trigger:
      if (!newTriggerData.hasOwnProperty("workflowTriggersID")) {
        newTriggerData.workflowTriggersID = 1000;
        newTriggerData.bNewlyCreated = true;
        newTriggerData.orderNumber = 0;

        newParsedData.workflowTriggersID = 1000;
        newParsedData.bNewlyCreated = true;
        newParsedData.orderNumber = 0;
      }

      newReferenceData.trigger = newTriggerData;

      setReferenceData(newReferenceData);
      setShowTriggerTypeSelector(false);
      setTempTriggerMilestoneData(null);

      setParsedData(newParsedData);

      // Clear trigger validation errors
      if (workflowBuilderErrors && workflowBuilderErrors.trigger) {
        setWorkflowBuilderErrors({ ...workflowBuilderErrors, trigger: [] });
      }
    }
  };

  return (
    <div
      className={`TypeSelector TriggerTypeSelector ${
        relevantErrors && relevantErrors.length > 0 ? "Error" : ""
      }`}
    >
      <label>{type === "trigger" ? "Trigger type:" : "Type:"}</label>

      <Dropdown
        onChange={handleChange}
        value={tempSelectedOption}
        options={triggerOptions}
        placeholder="Please select"
        roundedRectangle
        portalMode={true}
      />

      <MinimiseSelector
        setShowSelector={setShowTriggerTypeSelector}
        selectedValue={
          referenceData &&
          referenceData.trigger &&
          referenceData.trigger.workflowTriggerTypesID
            ? referenceData.trigger.workflowTriggerTypesID
            : null
        }
      />

      <button
        type="button"
        className={`SaveBtn ${
          (tempSelectedOption && triggerTypeId === tempSelectedOption.value) ||
          !tempSelectedOption
            ? "Disabled"
            : ""
        }`}
        onClick={handleSave}
      >
        Save
      </button>
    </div>
  );
};

export default TriggerTypeSelector;
